import { TruckLoadReport } from "@/models/TruckLoadReport";
import { trace } from "@/utilities/development";

interface TruckLoadReportState {
  truckLoadReport: TruckLoadReport;
}

const state: TruckLoadReportState = {
  truckLoadReport: {
    weight_total: 0,
    actual_purchase_total: 0,
    actual_sell_total: 0,
    actual_profit: 0,
    line_item_total: 0,
    line_item_summaries: [],
    il_summaries: [],
    sc_summaries: [],
    ilsctl_line_items: [],
    truck_load_line_items: [],
  },
};

const mutations = {
  LOAD_TRUCK_LOAD_REPORT(
    state: TruckLoadReportState,
    payload: TruckLoadReport,
  ) {
    state.truckLoadReport = payload;
  },
};

const actions = {
  loadTruckLoadReport(context: any, truckLoadReport: TruckLoadReport) {
    return new Promise((resolve, _reject) => {
      context.commit("LOAD_TRUCK_LOAD_REPORT", truckLoadReport);
      resolve(truckLoadReport);
    });
  },
};

const getters = {
  truckLoadReport: (state: TruckLoadReportState) => {
    return state.truckLoadReport;
  },
};

const truckLoadReportsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default truckLoadReportsModule;
